/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { REGISTRY_SIGNAL_LABELS } from "../api/registryDuplicates";
import { localDayEndIso, localDayStartIso, type FilterField } from "./filters";

const SCORE_FLOORS = [2, 3, 4, 5, 6, 7, 8, 9, 10].map((score) => ({
  value: String(score),
  label: `${score} or more`,
}));

export const REGISTRY_DUPLICATE_FILTER_FIELDS: FilterField[] = [
  {
    key: "entityType",
    label: "Type",
    kind: "choice",
    searchable: false,
    options: [
      { value: "PROVIDER", label: "Provider" },
      { value: "ORG", label: "Organization" },
    ],
    scim: (value) => `entityType eq "${value}"`,
  },
  {
    key: "status",
    label: "Status",
    kind: "choice",
    searchable: false,
    options: [
      { value: "OPEN", label: "Open" },
      { value: "DISMISSED", label: "Dismissed" },
      { value: "MERGED", label: "Merged" },
    ],
    scim: (value) => `status eq "${value}"`,
  },
  {
    key: "signal",
    label: "Signal",
    kind: "choice",
    searchable: false,
    options: Object.entries(REGISTRY_SIGNAL_LABELS).map(([value, label]) => ({ value, label })),
    scim: (value) => `signal eq "${value}"`,
  },
  {
    key: "minScore",
    label: "Score",
    kind: "choice",
    searchable: false,
    options: SCORE_FLOORS,
    scim: (value) => `score ge ${Number(value)}`,
  },
  {
    key: "createdAfter",
    label: "Opened after",
    kind: "date",
    scim: (value) => `createdAt ge "@${localDayStartIso(value)}"`,
  },
  {
    key: "createdBefore",
    label: "Opened before",
    kind: "date",
    scim: (value) => `createdAt le "@${localDayEndIso(value)}"`,
  },
];
